import React from "react";
import Main from "../components/Main";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import Sticky from "../components/Sticky";
import "../assets/styles/Main.scss";

const PageLayout = ({ children }) => {
  return (
    <div className="site-wrap">
      <Sticky>
        <Navbar />
      </Sticky>
      <Main>{children}</Main>

      <Footer />
    </div>
  );
};

export default PageLayout;
